import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '业务术语',
    type: 'BD_TERM',
}
